export default "__VITE_ASSET__e23999ed__"